<template>
    <Modal
        :value="deleteConfirmVisible"
        :scrollable="true"
        :mask-closable="false"
        :closable="false"
        :transfer="false"
        width="448px"
        class-name="delete-confirm"
        :footer-hide="true">
        <div class="flex flex--direction-column">
            <v-loading :loading="deleteLoading"></v-loading>
            <div class="flex flex--align-start" style="margin-bottom: 110px">
                <v-icon type="iconerror-24px1" size="48" style="color: #51458B; margin-right: 16px"></v-icon>
                <div>
                    <div class="delete-confirm__title">是否删除消息推送？</div>
                    <div class="delete-confirm__subtitle">消息推送删除后将无法恢复，且不再推送。</div>
                </div>
            </div>
            <div class="flex flex--justify-end flex--align-center">
                <div class="delete-confirm__cancel" @click="resetToBeDeleted">取消</div>
                <div class="delete-confirm__delete" @click="confirmDelete">删除</div>
            </div>
        </div>
    </Modal>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
    name: 'delete-confirm',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState("notification", ["deleteConfirmVisible", "deleteLoading"])
    },
    methods: {
        ...mapActions({
            resetToBeDeleted: "notification/resetToBeDeleted",
            confirmDelete: "notification/confirmDelete"
        }),
    }
}
</script>
<style lang="less">
    .delete-confirm {
        user-select: none;

        .ivu-modal{
            top: 304px;
            padding: 22px 24px 22px 16px;
        }

        &__title {
            font-weight: 500;
            font-size: 21px;
            line-height: 32px;
            color: #51458B;
        }

        &__subtitle {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: rgba(black, 0.54);
        }

        &__cancel {
            margin-right: 32px;

            font-size: 14px;
            font-weight: 500;
            color: @primary-color;
            line-height: 20px;

            &:hover {
                cursor: pointer;
            }
        }

        &__delete {
            font-size: 14px;
            font-weight: 500;
            color: rgba(black, 0.54);
            line-height: 20px;

            &:hover {
                cursor: pointer;
            }
        }
    }
</style>